require('./accountBlockedErrorModal.scss');
require('./accountBlockedErrorModal.override.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const OKModal = require('components/commons/OKModal/OKModal');
// @assets
const IconError = require("assets/images/icon-error.svg");

class AccountBlockedErrorModal extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        const { handleSubmit } = this.props;
        handleSubmit();
    }

    buildModalErrorContent() {
        const { title, description } = this.props;
        return (
            <ContentBox
                title={title}
                titleSeparator={true}
                leftIcon={{icon: IconError}}
                customClassName="account-blocked-error-modal"
                hasShadow={false}
            >
                <div className="account-blocked-error-modal__wrapper">
                    <p className="account-blocked-error-modal__text">{description}</p>
                </div>
            </ContentBox>
        );
    }

    buildModal() {
        const { showModal, hasCloseButton } = this.props;

        return (
            <OKModal
                content={this.buildModalErrorContent()}
                contentOverflow="auto"
                footerType="action"
                isOpen={showModal}
                shouldCloseOnOverlayClick={false}
                onCloseCallback={hasCloseButton && this.handleSubmit}
                customCloseButton={!hasCloseButton}
                secondaryButtonText="common-cancel"
                onSecondaryButtonClick={this.handleSubmit}
                overlayClassName="account-blocked-error-modal"
            />
        )
    }

    render() {
        return (
            <div>
                {this.buildModal()}
            </div>
        )
    }
}

AccountBlockedErrorModal.propTypes = {
    description: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    hasCloseButton: PropTypes.bool,
    showModal: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired
};

AccountBlockedErrorModal.defaultProps = {
    hasCloseButton: true
};

module.exports = AccountBlockedErrorModal;
